export default {
    namespaced: true,

    state: () => {
        return {
            loading: false,
            recipients: [],
        }
    },

    getters: {
        loading(state) {
            return state.loading;
        },

        recipients(state) {
            return state.recipients;
        }
    },

    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },

        setRecipient(state, recipients) {
            state.recipients = recipients;
        }
    },

    actions: {
        async getRecipients(context, payload) {
            context.commit('setLoading', true);

            await axios.post(`${this.state.host}/get-recipients`, payload, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                context.commit('setRecipient', res.data.recipients);
            })
            .catch(error => this.dispatch('snackbar/error', error))

            context.commit('setLoading', false);
        },

        async sendMessage(context, payload) {

            let isSuccess = false;
            
            await axios.post(`${this.state.host}/send-message`, payload, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                isSuccess = true;
                this.dispatch('snackbar/success', res.data.message);
                context.dispatch('getRecipients');
            })
            .catch(error => { 
                isSuccess = false;
                this.dispatch('snackbar/error', error);
            })

            return isSuccess;
        }
    }
}